import Script from "next/script";
import { GOOGLE_GSI_CLIENT_SRC } from "./google-one-tap";
import { useGoogleOneTap } from "./use-google-one-tap";

function GoogleOneTap() {
  const { isEligible, handleScriptReady } = useGoogleOneTap();

  if (!isEligible) {
    return null;
  }

  return (
    <Script
      id="google-gsi-client"
      src={GOOGLE_GSI_CLIENT_SRC}
      strategy="lazyOnload"
      onReady={handleScriptReady}
    />
  );
}

export { GoogleOneTap };
